import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState } from 'react';
import ajax from '@/scripts/ajax';
import dayjs from 'dayjs';
import useSearchList from '@/hooks/useSearchList';
import { SEARCH_ITEM_COL, SEARCH_ITEM_GUTTER } from '@/scripts/config';
import { useGetUserPortQuery } from '@/store/apiSlice';
import { Button, message, InputNumber, Dropdown, Popconfirm, DatePicker, Input, Card, Space, Form, Select, Col, Row, Table } from 'antd';
import { EditableProTable } from '@ant-design/pro-components';
import { getLabelFromMap, createJsonOptions } from '@/scripts/utils';
import { useGetEndPortQuery, useGetStartPortQuery } from '@/store/apiSlice';
import { IsHost } from '@/components/common/IsHost';
import { error } from 'bfj/src/events';
import ExportJsonExcel from 'js-export-excel'; //excel表格导出
const pageKey = 'GetRemindList'; //页面身份
export default function GoList() {
    const [dataSource, setData] = useState([]);
    const [total, setTol] = useState(0);
    const [pageSize, setSize] = useState(100);
    const [page, setPage] = useState(1);
    const { data: UserOptions } = useGetUserPortQuery();
    const [form] = Form.useForm();
    const [formSearch] = Form.useForm();
    const [hostOptions, setOptions] = useState([]);
    const { data: startPortOptions } = useGetStartPortQuery(1);
    const { data: endPortOptions } = useGetEndPortQuery(1);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dataSourceAll, setStateAll] = useState([]);
    const [labelTitle, setLabelTitle] = useState('导出全部页');
    const [isDisabled, setIsDisabled] = useState(false);

    let tableTitle = [
        '启运港',
        '目的港',
        '航线',
        '箱型',
        '开航时间',
        '基础运价',
        '总价',
        '来源',
        '查询时间',
        '是否作废',
        '船名航次',
        'price_id',
    ];
    let tableFilter = [
        'portofloading',
        'portofdischarge',
        'ship_name',
        'boxcode',
        'departuredate',
        'oceanfreightamount',
        'total_amount',
        'source',
        'insert_datetime',
        'is_use',
        'ship_info',
        'price_id',
    ];

    useEffect(() => {
        loading();
    }, []);

    const loading = () => {
        setOp();
        ajax.get('/maersk/remind/list?')
            .then((response) => {
                let data = response.data;
                setTol(response.total);
                data.map((item) => {
                    if (item.is_use === 0) {
                        item.is_use = '否';
                    } else if (item.is_use === 1) {
                        item.is_use = '是';
                    }
                    IsHost.forEach((i) => {
                        i.destinationcity_name.forEach((e) => {
                            if (e === item.portofdischarge) {
                                item.ship_name = i.host;
                            }
                        });
                    });
                    return item;
                });
                setData(data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const renderSearch = (pagination = {}) => {
        const current = pagination.current ?? page;
        const perPage = pagination.pageSize ?? pageSize;
        let params = formSearch.getFieldsValue() || {};
        params.per_page = perPage;

        if (params.insert_datetime) {
            params.insert_datetime = dayjs(params.insert_datetime).format('YYYY-MM-DD HH:mm:ss');
        }
        setSize(perPage);
        setPage(current);
        params.page = current;

        ajax.get('/maersk/remind/list', { params })
            .then((response) => {
                if (response && response.data) {
                    let data = response.data;
                    data = data.map((item) => {
                        if (item.is_use === 0) {
                            item.is_use = '否';
                        } else if (item.is_use === 1) {
                            item.is_use = '是';
                        }
                        IsHost.forEach((i) => {
                            i.destinationcity_name.forEach((e) => {
                                if (e === item.portofdischarge) {
                                    item.ship_name = i.host;
                                }
                            });
                        });
                        return item;
                    });
                    if (params.shipping_line !== undefined) {
                        const newData = data.filter((item) => item.ship_name === params.shipping_line);
                        setData(newData);
                        setTol(newData.length);
                    } else {
                        setData(data);
                        setTol(response.total ?? data.length);
                    }
                } else {
                    setData([]);
                    setTol(0);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    // 航线
    const setOp = () => {
        ajax.get('shippingLine')
            .then((response) => {
                setOptions(response);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    // 获取多选的id
    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    // 多选
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: 50,
    };

    // 批量作废
    const onMenuClick = () => {
        if (selectedRowKeys.length > 0) {
            const ids = selectedRowKeys.toString().replaceAll(',', ', ');
            let prm = {};
            prm.ids = ids;
            ajax.post('/maersk/remind/list', prm)
                .then((res) => {
                    message.success('作废成功');
                    setSelectedRowKeys([]);
                    setIsModalOpen(false);
                    renderSearch({ pageSize, page });
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            message.error('请选择要作废的数据');
        }
    };

    const del = (record) => {
        let prm = {
            ids: record.id.toString(),
        };
        if (record.is_use == '否') {
            ajax.post('/maersk/remind/list', prm)
                .then((res) => {
                    message.success('作废成功');
                    renderSearch({ pageSize, page });
                })
                .catch((err) => {
                    console.log(err);
                });
        } else if (record.is_use == '是') {
            message.error('请勿重复作废');
        }
    };

    const columns = [
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     // align: 'center',
        //     width: 80,
        //     sorter: (a, b) => a?.id - b?.id,
        // },
        {
            title: '启运港',
            dataIndex: 'portofloading',
            // align: 'center',
            width: 120,
            sorter: (a, b) => a['portofloading'].localeCompare(b['portofloading']),
        },
        {
            title: '目的港',
            dataIndex: 'portofdischarge',
            // align: 'center',
            width: 120,
            sorter: (a, b) => a['portofdischarge'].localeCompare(b['portofdischarge']),
        },
        {
            title: '航线',
            dataIndex: 'ship_name',
            // align: 'center',
            width: 120,
            sorter: (a, b) => a['ship_name'].localeCompare(b['ship_name']),
        },
        {
            title: '箱型',
            dataIndex: 'boxcode',
            // align: 'center',
            width: 80,
            sorter: (a, b) => a['boxcode'].localeCompare(b['boxcode']),
        },
        {
            title: '开航时间',
            dataIndex: 'departuredate',
            // align: 'center',
            width: 100,
            sorter: (a, b) => +new Date(a.departuredate) - +new Date(b.departuredate),
        },
        {
            title: '基础运价',
            dataIndex: 'oceanfreightamount',
            // align: 'center',
            width: 80,
            sorter: (a, b) => a?.oceanfreightamount - b?.oceanfreightamount,
        },
        {
            title: '总价',
            dataIndex: 'total_amount',
            // align: 'center',
            width: 120,
            sorter: (a, b) => a?.total_amount - b?.total_amount,
        },
        {
            title: '来源',
            dataIndex: 'source',
            // align: 'center',
            width: 120,
            sorter: (a, b) => a['source'].localeCompare(b['source']),
        },

        {
            title: '查询时间',
            dataIndex: 'insert_datetime',
            // align: 'center',
            width: 100,
            sorter: (a, b) => +new Date(a.insert_datetime) - +new Date(b.insert_datetime),
        },

        {
            title: '是否作废',
            dataIndex: 'is_use',
            // align: 'center',
            width: 120,
            sorter: (a, b) => a['is_use'].localeCompare(b['is_use']),
        },
        {
            title: '船名航次',
            dataIndex: 'ship_info',
            // align: 'center',
            width: 120,
            sorter: (a, b) => a['ship_info'].localeCompare(b['ship_info']),
        },
        {
            title: 'price_id',
            dataIndex: 'price_id',
            // align: 'center',
            width: 120,
            sorter: (a, b) => a?.price_id - b?.price_id,
        },
        {
            title: '作废',
            width: 80,
            dataIndex: 'operation',
            render: (_, record) => (dataSource.length >= 1 ? <Button onClick={() => del(record)}>作废</Button> : null),
        },
    ];

    const onShowSizeChange = (pagination) => {
        renderSearch(pagination || { current: page, pageSize });
    };

    // 导出
    const ExcelItems = [
        {
            key: '1',
            label: '导出当前页',
        },
        {
            key: '2',
            label: labelTitle,
            disabled: isDisabled,
        },
    ];

    const onExcel = (e) => {
        let tableData = [];
        let options = {};
        if (e.key === '1') {
            dataSource.map((item) => {
                let objRow = {
                    portofloading: item.portofloading,
                    portofdischarge: item.portofdischarge,
                    ship_name: item.ship_name,
                    boxcode: item.boxcode,
                    departuredate: item.departuredate,
                    oceanfreightamount: item.oceanfreightamount,
                    total_amount: item.total_amount,
                    source: item.source,
                    insert_datetime: item.insert_datetime,
                    is_use: item.is_use,
                    ship_info: item.ship_info,
                };
                return tableData.push(objRow);
            });
            options.fileName = '订单列表';
            options.datas = [
                {
                    sheetData: tableData,
                    sheetName: 'sheet',
                    sheetFilter: tableFilter,
                    sheetHeader: tableTitle,
                },
            ];
            const toExcel = new ExportJsonExcel(options);
            toExcel.saveExcel();
        } else if (e.key === '2') {
            setLabelTitle('正在导出');
            setIsDisabled(true);
            const params = formSearch.getFieldsValue() || {};
            if (params.insert_datetime) {
                params.insert_datetime = dayjs(params.insert_datetime).format('YYYY-MM-DD HH:mm:ss');
            }
            params.per_page = total || 10000;
            params.page = 1;
            ajax.get('/maersk/remind/list', { params })
                .then((response) => {
                    setLabelTitle('导出全部页');
                    setIsDisabled(false);
                    message.success('导出成功');
                    let data = response.data || [];
                    data = data.map((item) => {
                        if (item.is_use === 0) {
                            item.is_use = '否';
                        } else if (item.is_use === 1) {
                            item.is_use = '是';
                        }
                        IsHost.forEach((i) => {
                            i.destinationcity_name.forEach((e) => {
                                if (e === item.portofdischarge) {
                                    item.ship_name = i.host;
                                }
                            });
                        });
                        return item;
                    });
                    setStateAll(data);
                    let tableData = [];
                    data.map((item) => {
                        let objRow = {
                            portofloading: item.portofloading,
                            portofdischarge: item.portofdischarge,
                            ship_name: item.ship_name,
                            boxcode: item.boxcode,
                            departuredate: item.departuredate,
                            oceanfreightamount: item.oceanfreightamount,
                            total_amount: item.total_amount,
                            source: item.source,
                            insert_datetime: item.insert_datetime,
                            is_use: item.is_use,
                            ship_info: item.ship_info,
                        };
                        return tableData.push(objRow);
                    });
                    const options = {
                        fileName: '订单列表',
                        datas: [
                            {
                                sheetData: tableData,
                                sheetName: 'sheet',
                                sheetFilter: tableFilter,
                                sheetHeader: tableTitle,
                            },
                        ],
                    };
                    const toExcel = new ExportJsonExcel(options);
                    toExcel.saveExcel();
                })
                .catch((error) => {
                    console.log(error);
                    setLabelTitle('导出全部页');
                    setIsDisabled(false);
                });
        }
    };

    return (
        <div className="list">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <PageHeader title="提醒列表" sticky></PageHeader>
                </div>
                <Row>
                    <Col style={{ marginRight: '5px' }}>
                        <Button type="primary" onClick={() => onMenuClick()}>
                            批量作废
                        </Button>
                    </Col>
                    <Col>
                        <Dropdown menu={{ items: ExcelItems, onClick: onExcel }}>
                            <Button>
                                <Space>Excel导出</Space>
                            </Button>
                        </Dropdown>
                    </Col>
                </Row>
            </div>
            <Card className="ax-search-card">
                <Form form={formSearch} autoComplete="off">
                    <Row gutter={SEARCH_ITEM_GUTTER}>
                        <Col style={{ width: '20%' }}>
                            <Form.Item label="起运" name="origincity_name">
                                <Select
                                    options={createJsonOptions(startPortOptions)}
                                    filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col style={{ width: '20%' }}>
                            <Form.Item label="目的" name="destinationcity_name">
                                <Select
                                    options={createJsonOptions(endPortOptions)}
                                    filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Form.Item label="箱型" name="boxcode">
                                <Select
                                    style={{ width: '200px', marginRight: '40px' }}
                                    options={createJsonOptions(['20DRY', '40HDRY', '40NOR', '45HDRY'])}
                                    showSearch
                                    filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                                    allowClear
                                ></Select>
                            </Form.Item>
                            <Form.Item label="航线" style={{ width: '200px' }} name="shipping_line">
                                <Select options={createJsonOptions(hostOptions)} showSearch allowClear></Select>
                            </Form.Item>
                        </Col>
                        <Col style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Form.Item style={{ marginRight: '40px' }} label="选择时间" name="insert_datetime">
                                <DatePicker showTime />
                            </Form.Item>
                            <span>
                                <Button onClick={() => renderSearch({ current: 1, pageSize })} type="primary">
                                    搜索
                                </Button>
                            </span>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Form form={form} component={false}>
                <Table
                    rowSelection={rowSelection}
                    rowKey={(record) => record.id}
                    bordered
                    dataSource={dataSource}
                    columns={columns}
                    pagination={{
                        total: total,
                        showSizeChanger: true,
                        defaultPageSize: 100,
                        pageSizeOptions: [20, , 50, 100, 200, 500],
                    }}
                    onChange={onShowSizeChange}
                />
            </Form>
        </div>
    );
}
